import { Collection } from 'modules/core/lib/mobx-rest'

import Shift from 'modules/shift_management/store/api/models/Shift'

class Shifts extends Collection<Shift> {
  get cacheKey(): string {
    return 'shifts'
  }
  model() {
    return Shift
  }
}

const singleton: Shifts = new Shifts()

export default singleton
